import { Navigate, useLocation } from 'react-router-dom';

/** Bookmarks and stored agent previews now open the combined document history. */
export function SigningWorkspace() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/quotes', search, hash }} replace />;
}
